import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-chevron-left.tsx
/**
* icon.16.chevron.left
*
* Keywords: arrow, backward, navigation, previous, return, west, direction, pointer
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTguNTI2IDUuNTI0YS41MDEuNTAxIDAgMCAxIC43MDcuNzA4TDcuNDY1IDhsMS43NjggMS43NjdhLjUuNSAwIDAgMS0uNzA3LjcwN2wtMi4xMjEtMi4xMmEuNS41IDAgMCAxIDAtLjcwOHoiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=9504-4284
*/
const Icon16ChevronLeft = memo(function Icon16ChevronLeft(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M8.526 5.524a.501.501 0 0 1 .707.708L7.465 8l1.768 1.767a.5.5 0 0 1-.707.707l-2.121-2.12a.5.5 0 0 1 0-.708z"
		})
	});
});
//#endregion
export { Icon16ChevronLeft };

//# sourceMappingURL=icon-16-chevron-left.js.map